import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {ThemeProvider, Typography} from '@mui/material';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterLuxon} from '@mui/x-date-pickers/AdapterLuxon';
import React from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import './App.css';
import {AppBarComponent} from './components/AppBar/AppBarComponent';
import {AuthProvider} from './firebase/firebaseAuth';
import {SecurityRole} from './models/UserData';
import {AdminEditPage} from './pages/admin/AdminEditPage';
import {Hompepage} from './pages/homepage/Homepage';
import Login from './pages/login/Login';
import {PrivacyPolicy} from './pages/login/PrivacyPolicy';
import {UserDetailsPage} from './pages/user/UserDetailsPage';
import PrivateRoute from './PrivateRoute';
import {theme} from './Theme';
import {I18nProvider} from "./i18nProvider";
import {ResultsPage} from "./pages/results/ResultsPage";
import {Box} from "@mui/system";

function App() {

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: "column",
      minHeight: "100%"
    }}>
      <Box pb={2}>
        <ThemeProvider theme={theme}>
          <AuthProvider>
            <I18nProvider>
              <LocalizationProvider dateAdapter={AdapterLuxon}>
                <BrowserRouter>
                  <Routes>
                    <Route path="/Login" element={<Login/>}/>
                    <Route path="/Results" element={<ResultsPage/>}/>
                    <Route path='/privacyPolicy' element={<PrivacyPolicy/>}/>
                    <Route path="/*" element={
                      <PrivateRoute>
                        <AppBarComponent/>
                        <Routes>
                          <Route path="/" element={<Hompepage/>}/>
                          <Route path="/user-details" element={<UserDetailsPage showBetaButton={true}/>}/>
                        </Routes>
                      </PrivateRoute>}/>
                    <Route path="/admin" element={
                      <PrivateRoute role={SecurityRole.ADMIN}>
                        <AppBarComponent/>
                        <AdminEditPage/>
                      </PrivateRoute>}/>
                  </Routes>
                </BrowserRouter>
              </LocalizationProvider>
            </I18nProvider>
          </AuthProvider>
        </ThemeProvider>
      </Box>
      <Typography align={"center"} fontSize={'x-small'} sx={{
        position: "absolute",
        bottom: "0",
        width: "100%",
      }
      }>2023 © Mateusz Mańka Development, mateusz@manka.dev</Typography>

    </Box>
  );
}

export default App;
